module.exports = __webpack_public_path__ + "img/move3.10891cb1.png";